import { observable } from 'mobx';

export type LegTerminalResponseArgs = {
  code: string;
  date: string;
  name: string;
  time: string;
  time_full: string;
};

export type LegTerminalArgs = {
  code: string;
  date: string;
  name: string;
  time: string;
  timeFull: string;
};

export const convertLegTerminalResponseToArgs = (response: LegTerminalResponseArgs) => {
  const args: LegTerminalArgs = {
    code: response.code,
    date: response.date,
    name: response.name,
    time: response.time,
    timeFull: response.time_full
  };
  return args;
};

export default class LegTerminal {
  @observable code: string;
  @observable date: string;
  @observable name: string;
  @observable time: string;
  @observable timeFull: string;

  constructor(args: LegTerminalArgs) {
    this.code = args.code;
    this.date = args.date;
    this.name = args.name;
    this.time = args.time;
    this.timeFull = args.timeFull;
  }
}
